// extracted by mini-css-extract-plugin
export var alignCenter = "_6s-d";
export var bannerShown = "_6s-6";
export var buttonContent = "_6s-0";
export var cardList = "_6s-1";
export var centerContent = "_6s-2";
export var chevron = "_6s-3";
export var closePanelButton = "_6s-k";
export var conversationContextContainer = "_6s-l";
export var conversationDetailContainer = "_6s-4";
export var detailWrapper = "_6s-7";
export var dropdownButton = "_6s-e";
export var dropdownTitle = "_6s-9";
export var fullHeight = "_6s-5";
export var hidden = "_6s-a";
export var icon = "_6s-b";
export var mergeSuggestionWrapper = "_6s-m";
export var panel = "_6s-i";
export var portalButtonsWrapper = "_6s-c";
export var right = "_6s-j";
export var tableSummaryContainer = "_6s-8";
export var tableSummaryHeader = "_6s-g";
export var threeDotsButton = "_6s-f";
export var wide = "_6s-h";